import { KeyboardArrowDown } from '@mui/icons-material';
import { Box, CircularProgress, MenuItem, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/cabecalho.css';
import PopoverSecretaria from '../PopoverSecretaria';
import ReactComponent from '../ReactComponent';

class ListaPautas extends ReactComponent {
    openMenuSessoes = false;

    handleCloseMenuSessoes = () => {
        this.openMenuSessoes = false;
    };

    handleClickMenuSessoes = () => {
        this.openMenuSessoes = true;
    };

    handleClickPauta = (idPauta) => {
        this.handleCloseMenuSessoes();
        this.pautaJulgamentoStore.idPautaSelecionada = idPauta;
        this.pautaJulgamentoStore.inicializarPautaJulgamento();
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            openMenuSessoes: observable,
            handleCloseMenuSessoes: action,
            handleClickMenuSessoes: action,
            handleClickPauta: action,
            descricaoPautaSelecionada: computed,
            pautasSessao: computed,
            tooltipPautaSelecionada: computed,
            qtdProcessosPautaSelecionada: computed
        });
    }

    get descricaoPautaSelecionada() {
        return this.pautaJulgamentoStore.pautaSelecionada
            ? this.pautaJulgamentoStore.pautaSelecionada.descricao + ' (' + this.qtdProcessosPautaSelecionada + ')'
            : 'Selecione uma pauta...';
    }

    get pautasSessao() {
        let retorno = {};
        if (this.sessaoStore.sessaoSelecionada) {
            retorno = this.sessaoStore.sessaoSelecionada.descricaoPorSessao || {};
        }
        return retorno;
    }

    getQtdProcessosPauta(idPauta) {
        return this.sessaoStore.sessaoSelecionada
            ? this.sessaoStore.sessaoSelecionada.quantidadesTotaisProcessos[idPauta]
            : 0;
    }

    get tooltipPautaSelecionada() {
        return this.pautaJulgamentoStore.pautaSelecionada
            ? this.pautaJulgamentoStore.pautaSelecionada.descricao +
                  ': ' +
                  this.qtdProcessosPautaSelecionada +
                  ' processo(s) EM PAUTA/SESSÃO'
            : '';
    }

    get qtdProcessosPautaSelecionada() {
        return this.getQtdProcessosPauta(this.pautaJulgamentoStore.idPautaSelecionada);
    }

    render() {
        return (
            <>
                <Box style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>
                    <Typography>Pauta:</Typography>
                </Box>
                <Box
                    id="menuPautasSessao"
                    onClick={this.handleClickMenuSessoes}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        boxSizing: 'border-box',
                        borderColor: 'white',
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        height: '30px',
                        paddingRight: '4px',
                        marginLeft: '8px'
                    }}
                >
                    <Typography
                        component="h5"
                        color="inherit"
                        style={{
                            fontSize: '1em',
                            fontWeight: 'normal',
                            margin: '0px 8px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '400px',
                            color: 'white'
                        }}
                    >
                        {!this.pautaJulgamentoStore.pautaSelecionada &&
                        this.pautaJulgamentoStore.carregandoProcessos &&
                        this.sessaoStore.carregandoProcessos ? (
                            <CircularProgress
                                size={14}
                                color="inherit"
                            />
                        ) : (
                            <Tooltip title={<Typography>{this.tooltipPautaSelecionada}</Typography>}>
                                <Typography>{this.descricaoPautaSelecionada}</Typography>
                            </Tooltip>
                        )}
                    </Typography>
                    <KeyboardArrowDown style={{ fill: 'white' }} />
                </Box>
                <PopoverSecretaria
                    open={this.openMenuSessoes}
                    onClose={this.handleCloseMenuSessoes}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                    elevation={12}
                    anchorEl={() => document.getElementById('menuPautasSessao')}
                    style={{ padding: '0px', zIndex: '999' }}
                >
                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {Object.keys(this.pautasSessao).map((idPauta) => (
                            <div
                                key={this.nextKey}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    height: '60px'
                                }}
                            >
                                <MenuItem
                                    style={{ width: '100%', height: '60px' }}
                                    key={this.nextKey}
                                    value={idPauta}
                                    onClick={() => this.handleClickPauta(idPauta)}
                                >
                                    {this.pautasSessao[idPauta] &&
                                        this.renderConteudoItemMenu(this.pautasSessao[idPauta], idPauta)}
                                </MenuItem>
                            </div>
                        ))}
                    </div>
                </PopoverSecretaria>
            </>
        );
    }

    renderConteudoItemMenu(descricao, idPauta) {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                {descricao + ' (' + this.getQtdProcessosPauta(idPauta) + ')'}
            </div>
        );
    }
}

export default inject('stores')(observer(ListaPautas));
